import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { PartinersComponent } from './partiners.component';
import { PartinersDetailComponent } from './partiners-detail/partiners-detail.component';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { PartinerFormComponent } from './partiner-form/partiner-form.component';

const routes:Routes=[
  {path:'',redirectTo:'list', pathMatch:'full'},
  {path:'list',component:PartinersComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin"]}},
  {path:'new',component:PartinerFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
  {path:'edit',component:PartinerFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
  {path:'detail',component:PartinersDetailComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin"]}},
]

  // o Administrador Khuzela faz CRUD do Produto
  // o Utilizador Khuzela  só Lê
  // o Manager do Clube não faz Nada
  // o Utilizador do Clube não faz Nada

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class PartinersRoutingModule { }
